/**
 * Created by Simon Julius on 08/04/2022.
 */
// import { getBaseUrl } from '@/utils/app-settings'

export const carbonZeroWidgetConfigs = () => ({
  baseURL: 'https://api.staging.paylater.ng/',
  'x-entity': 'ng'
})
